<div class="inbuilt-column-chart-v2-wrapper">
  @if (loading) {
  <div class="column-chart-state" aria-live="polite" aria-busy="true">
    <div class="spinner"></div>
    <div class="loader-text">Loading column chart...</div>
  </div>
  } @if (!loading && noDataFound) {
  <div class="column-chart-state">
    No data found.
  </div>
  }

  <div class="column-chart-scroll-area">
    <div #columnChartContainer class="column-chart-v2-container"></div>
  </div>

  @if (!loading && showLegend) {
  <div class="series-legend-row">
    @for (item of legendItems; track item) {
    <div class="legend-item">
      <span class="legend-color" [style.background-color]="item.color"></span>
      <span class="legend-label">{{ item.label }}</span>
    </div>
    }
  </div>
  }
</div>
